const situations = [
  { icon: 'ri-task-line', title: 'Постановка задачи', desc: 'Когда руководитель ставит задачу и согласовывает, что именно и к какому сроку должно быть сделано.' },
  { icon: 'ri-calendar-2-line', title: 'Согласование сроков', desc: 'Когда нужно договориться о дедлайнах и приоритетах, не превращая разговор в торг или давление.' },
  { icon: 'ri-share-forward-line', title: 'Распределение ответственности', desc: 'Когда определяется, кто за что отвечает и какой результат считается выполненным.' },
  { icon: 'ri-line-chart-line', title: 'Обсуждение результата', desc: 'Когда разбирается итог работы: что получилось, что нет и почему.' },
  { icon: 'ri-refresh-line', title: 'Требование изменить поведение', desc: 'Когда руководителю нужно добиться от сотрудника изменения привычного способа работы.' },
  { icon: 'ri-scales-3-line', title: 'Решение конфликта', desc: 'Когда между сотрудниками или подразделениями возникает спор, который мешает работе.' },
  { icon: 'ri-funds-line', title: 'Согласование ресурсов', desc: 'Когда нужно договориться о людях, времени, бюджете и приоритетах с другими отделами.' },
  { icon: 'ri-bar-chart-box-line', title: 'Обсуждение KPI', desc: 'Когда разбираются показатели и ожидания по результату сотрудника или подразделения.' },
  { icon: 'ri-file-check-line', title: 'Получение обязательств', desc: 'Когда руководителю нужно, чтобы сотрудник явно принял на себя обязательство выполнить задачу.' },
  { icon: 'ri-building-2-line', title: 'Согласование с подразделениями', desc: 'Когда решения нужно увязать с интересами и планами других отделов компании.' },
  { icon: 'ri-vip-crown-line', title: 'Взаимодействие с руководством', desc: 'Когда руководитель сам договаривается с собственником или вышестоящим руководством о целях, ресурсах и изменениях.' },
];

export default function WhatAreManagerialNegotiations() {
  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-3">
          Управленческие переговоры — это не только переговоры о должности или зарплате
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          Руководитель постоянно находится в переговорном взаимодействии — даже когда не называет это переговорами
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-12">
          {situations.map((item) => (
            <div key={item.title} className="bg-white rounded-xl border border-gray-200 p-5 md:p-6 hover:border-teal-300 transition-colors">
              <div className="w-10 h-10 rounded-full bg-teal-100 flex items-center justify-center mb-4">
                <i className={`${item.icon} text-teal-700 text-lg`}></i>
              </div>
              <h3 className="font-bold text-gray-900 text-sm mb-2">{item.title}</h3>
              <p className="text-gray-600 text-xs leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>

        <div className="bg-teal-50 rounded-xl border border-teal-200 p-6 md:p-8 max-w-4xl mx-auto">
          <p className="text-base text-teal-800 leading-relaxed">
            Формальная должность даёт руководителю полномочия, но не гарантирует согласия, ответственности и качественного исполнения. Поэтому управленческие переговоры позволяют добиваться результата через договорённости, влияние и ясные правила взаимодействия — а не только через приказ.
          </p>
        </div>
      </div>
    </section>
  );
}